import React from 'react';
import { useEffect } from 'react';
const NotFoundPage = () => {
    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, []);

    return (
        <div className="loginPageBackgroundDesktopV2 bg-white tc pa5 pt1  vh-50 flex flex-column content-center justify-center items-center">
            <div className="notFoundPage bg-white">
                <div className="pa3 fw6 f3">{translate("Seite nicht gefunden")} </div>
                <div>{translate("notFound_desc")}</div>
            </div>
        </div>
    );
}

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.js